// ** React Imports
import { Fragment } from 'react'

import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Custom Components Import
import MessagesLog from '../telegram/telegram-log'
import Image from 'next/image'
import { useTranslation } from 'src/utils/i18n'

// ** Styled Components
const ChatWrapperStartChat = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  height: '100%',
  display: 'flex',
  borderRadius: 1,
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: theme.palette.action.hover
}))

const KikContent = props => {
  const { t } = useTranslation('common')

  const { data, store, hidden, mdAbove, handleLeftSidebarToggle, handleUserProfileRightSidebarToggle, headImg } = props

  const handleStartConversation = () => {
    if (!mdAbove) {
      handleLeftSidebarToggle()
    }
  }

  const renderContent = () => {
    if (store) {
      const selectedMessage = store.selectedMessage

      if (!selectedMessage) {
        return (
          <ChatWrapperStartChat
            sx={{
              ...(mdAbove ? { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 } : {})
            }}
          >
            <Box
              onClick={handleStartConversation}
              sx={{
                px: 6,
                py: 2.25,
                boxShadow: 3,
                borderRadius: 5,
                backgroundColor: 'background.paper',
                cursor: mdAbove ? 'default' : 'pointer'
              }}
            >
              <Typography sx={{ fontWeight: 600 }}>{t('Start Conversation')}</Typography>
            </Box>
          </ChatWrapperStartChat>
        )
      } else {
        return (
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              height: '100%',
              backgroundColor: 'white'
            }}
          >
            {/* <Box
              sx={{
                py: 3,
                px: 5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: theme => `1px solid ${theme.palette.divider}`,
                backgroundColor: '#3496D2',
                height: 60
              }}
            >
              <Box
                sx={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: 'auto' }}
                className='sm:w-full '
              >
                {mdAbove ? null : (
                  <IconButton onClick={handleLeftSidebarToggle} sx={{ mr: 2, color: 'white' }}>
                    <Icon icon='mdi:menu' />
                  </IconButton>
                )}
                <Box
                  onClick={handleUserProfileRightSidebarToggle}
                  sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                >
                  <div sx={{ display: 'flex', flexDirection: 'column' }} className='flex items-center'>
                    <div className=''>
                      <Image src={headImg} alt='' width={38} height={38} className=' rounded-full' />
                    </div>
                    <div className='ml-2 font-bold text-[14px]'>
                      <h2 className='text-white'>{selectedMessage.chat.contact.fullName}</h2>
                      <p className='text-[12px] font-medium text-white text-opacity-90'>
                        {selectedMessage.chat.contact.label}
                      </p>
                    </div>
                  </div>
                </Box>
                <div></div>
              </Box>
            </Box> */}

            {selectedMessage && store.userProfile ? (
              <MessagesLog hidden={hidden} data={{ ...selectedMessage }} />
            ) : null}
          </Box>
        )
      }
    } else {
      return null
    }
  }

  return renderContent()
}

export default KikContent
